module.exports = __webpack_public_path__ + "img/hot@2x1.a60e14d9.png";